import { useFlow } from "@rapid/contexts/FlowContext";
import { ActionCard } from "./ActionCard";
import { InferenceStatus, useInferenceQueueItem } from "@rapid/store";
import { useMemo } from "react";
import { useModel } from "@rapid/contexts/ModelContext";
import { useDownloadAnnotatedFile } from "@rapid/hooks/useDownloadAnnotatedFile";
import { useCurrentMedia } from "@rapid/store";

export const DownloadActionCard = ({ disabled: disabledProp = false }: { disabled?: boolean }) => {
    const { task } = useFlow();
    const { isTestingNewFiles, isDownloading } = useModel();
    const currentMedia = useCurrentMedia();
    const inferenceQueueItem = useInferenceQueueItem(currentMedia?.file.id);

    // Use shared download hook
    const handleDownloadAnnotatedFileClick = useDownloadAnnotatedFile({
        watermarkUrl: "https://rapid.roboflow.com",
        task
    });

    const disabled = useMemo(() => {
        if (disabledProp) return true;
        if (isDownloading || isTestingNewFiles) return true;
        if (inferenceQueueItem?.status !== InferenceStatus.COMPLETED) return true;
        return false;
    }, [disabledProp, isDownloading, isTestingNewFiles, inferenceQueueItem]);

    return (
        <ActionCard
            title={currentMedia?.file.isVideo ? "Download Video" : "Download Image"}
            icon={isDownloading ? "far fa-spinner fa-spin" : "far fa-download"}
            onClick={disabled ? undefined : handleDownloadAnnotatedFileClick}
            className={disabled ? "pointer-events-none opacity-50" : ""}
        />
    );
};
